import React from 'react';
import { BookOpenIcon, ClockIcon, TrophyIcon, BrainIcon } from 'lucide-react';
const StatsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1044">
      <div className="p-4 flex justify-between items-center" data-id="element-1045">
        <h2 className="text-base font-semibold text-gray-800" data-id="element-1046">
          Statistiche di Studio
        </h2>
        <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-1047">
          Visualizza Report
        </button>
      </div>
      <div className="p-4" data-id="element-1048">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1049">
          <StatCard icon={<ClockIcon className="text-gray-600" size={20} data-id="element-1051" />} label="Ore di Studio" value="32.5" trend="+2.5 questa settimana" trendUp={true} data-id="element-1050" />
          <StatCard icon={<BookOpenIcon className="text-gray-600" size={20} data-id="element-1053" />} label="Lezioni Completate" value="12" trend="di 28 totali" data-id="element-1052" />
          <StatCard icon={<TrophyIcon className="text-gray-600" size={20} data-id="element-1055" />} label="Quiz Superati" value="8" trend="Media: 92%" trendUp={true} data-id="element-1054" />
          <StatCard icon={<BrainIcon className="text-gray-600" size={20} data-id="element-1057" />} label="Streak di Studio" value="5" trend="giorni consecutivi" trendUp={true} data-id="element-1056" />
        </div>
      </div>
    </div>;
};
interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  trend: string;
  trendUp?: boolean;
}
const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  trend,
  trendUp
}) => {
  return <div className="p-3 border border-gray-200 rounded-lg" data-id="element-1058">
      <div className="flex items-center space-x-2 mb-2" data-id="element-1059">
        {icon}
        <div className="text-lg font-medium text-gray-800" data-id="element-1060">{value}</div>
      </div>
      <div className="text-sm text-gray-600" data-id="element-1061">{label}</div>
      <div className={`text-xs ${trendUp ? 'text-custom-green' : 'text-gray-500'} mt-1`} data-id="element-1062">
        {trend}
      </div>
    </div>;
};
export default StatsWidget;